module.exports = __webpack_public_path__ + "img/log-out.03944d85.svg";